import React, { useState, useEffect } from "react";

import api from "../services/api";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//Feather
import {
  AlertTriangle,
  MessageCircle
} from 'react-feather';

import {
  CBadge,
  //Table
  CTable,
  CAvatar,
  CTableRow,
  CTableHead,
  CTableBody,
  CTableDataCell,
  CTableHeaderCell
} from "@coreui/react";


//Feather icons
import {
  X,
  Search
} from "react-feather";

//Components
import Box from "../components/Box";
import Popup from "../components/Popup";
import Button from "../components/Button";
import PopupSocialMedia from "../components/PopupSocialMedia";
import PopupTags from "../components/PopupTags";
import PopupSocialMediaUserOutdated from "../components/PopupSocialMediaUserOutdated";

//SVG"s
import Any from "../svgs/Any";

import { useAuth } from "../providers/auth";
import LoadingCenter from "../components/LoadingCenter";
import ChartHours from "../components/ChartHours";

function JuridicCustomers() {
  const { user } = useAuth();

  const [buttonPopupSocialMediaFilter, setButtonPopupSocialMediaFilter] = useState(false);
  const [idCustomer, setIdCustomer] = useState("");
  const [infoLoadingCriarChat, setInfoLoadingCriarChat] = useState(false);
  const [socialMedias, setSocialMedias] = useState([]);

  const [buttonPopup, setButtonPopup] = useState(false);
  const [search, setSearch] = useState("");

  const [info, setInfo] = useState();
  const [infoLoading, setInfoLoading] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(true);

  const [buttonPopupTags, setButtonPopupTags] = useState(false);
  const [buttonPopupSocialMedia, setButtonPopupSocialMedia] = useState(false);

  async function fetchCustomers() {
    const options = { headers: { "Authorization": "Bearer " + user.token } };

    setCustomersLoading(true);

    try {
      const response = await api.get("/users/juridic", options);

      setCustomers(response.data.dados);

    } catch (error) {
      console.log(error);
    } finally {
      setCustomersLoading(false);
    }
  }

  async function fetchCustomerById(id) {
    const options = { headers: { "Authorization": "Bearer " + user.token } };

    try {
      setInfoLoading(true);
      const response = await api.get("/users/" + id, options);
      setInfo(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setInfoLoading(false);
    }
  }

  useEffect(() => {
    fetchCustomers();
  }, []);

  //MEDIAS/TAGS
  const [media, setMedia] = useState("");
  const [access, setAccess] = useState("");
  const [tags, setTags] = useState([]);

  async function handleSearch(e) {
    if (e.key === "Enter") {
      setCustomersLoading(true);
      try {
        const response = await api.get(`/users/juridic/customers?social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

        setCustomers(response.data.dados);
      } catch (error) {
        console.log(error);
      } finally {
        setCustomersLoading(false);
      }
    }
  }

  const fetchCustomersWithFilter = async () => {
    setCustomersLoading(true);

    try {
      const response = await api.get(`/users/juridic/customers?social_media=${media}&search=${search}`, { headers: { "Authorization": "Bearer " + user.token } });

      setCustomers(response.data.dados);
      setButtonPopupTags(false);
      setButtonPopupSocialMedia(false);
    } catch (err) {
      console.log(err);
    } finally {
      setCustomersLoading(false);
    }
  }

  useEffect(() => {
    if (tags.length) fetchCustomersWithFilter();
  }, [tags]);

  useEffect(() => {
    if (media !== "") fetchCustomersWithFilter();
  }, [media]);

  useEffect(() => {
    if (access !== "") fetchCustomersWithFilter();
  }, [access]);

  async function pegaSocialMedia(id) {
    const options = { headers: { "Authorization": "Bearer " + user.token } };
    try {

      setInfoLoadingCriarChat(true);

      const response = await api.get("/users/socialmedia/" + id, options);
      setSocialMedias(response.data);
      setIdCustomer(id);

    } catch (error) {
      console.log(error);
    } finally {

      setInfoLoadingCriarChat(false);

    }
  }

  return (
    <div className="customer-grid">

      <PopupSocialMediaUserOutdated setSelectedMedia={setMedia} socialMedias={socialMedias} trigger={buttonPopupSocialMediaFilter} setTrigger={setButtonPopupSocialMediaFilter} idCustomer={idCustomer} infoLoadingCriarChat={infoLoadingCriarChat} />

      <Popup title="Gerenciar tags" trigger={buttonPopup} setTrigger={setButtonPopup} >
        <div className="padding-inner">
          <span className="popup-label">Tags do seu cliente</span>

          <div className="inner-search ml-20" style={{ height: "45px" }}>
            <div className="search-icon">
              <Search size={24} />
            </div>
            <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
          </div>

          <div className="tag-delete">
            <div className="tag-delete-inner">
              <span>#colheitadeira</span>
              <button className="btn-tag-delete">
                <X size={18} />
              </button>
            </div>
          </div>
        </div>

        {/* <div className="padding-lbr">
          Lorem ipsum
        </div> */}

        <div className="padding-lbr">
          <Button title="Adicionar" type="submit" color="green" width="full" loading={false} onClick={() => { }} />
        </div>
      </Popup>

      <PopupTags setSelectedTags={setTags} trigger={buttonPopupTags} setTrigger={setButtonPopupTags} />

      <PopupSocialMedia setSelectedMedia={setMedia} trigger={buttonPopupSocialMedia} setTrigger={setButtonPopupSocialMedia} />

      <div className="customer-container">

        <div className="header flex-separate border-bottom fix-top">

          <span>
            Clientes inadimplentes
          </span>

          <div className="navigation">
            <div className="inner-search ml-20" style={{ height: "45px" }}>
              <div className="search-icon">
                <Search size={24} />
              </div>
              <input className="search-input" onKeyPress={handleSearch} type="text" placeholder="Pressione enter p/ pesquisar" onChange={e => setSearch(e.target.value)} value={search} />
            </div>
          </div>

        </div>

        <div className="table-container">
          {customersLoading ? (
            <LoadingCenter />
          ) : (
            <>
              <CTable hover>
                <CTableHead>
                  <CTableRow>
                    <CTableHeaderCell scope="col">
                      <span className="text-color">Foto</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      <span className="text-color">Nome completo</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      <span className="text-color">Data Cadastro</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      <span className="text-color">Status</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      <span className="text-color">Aprovação</span>
                    </CTableHeaderCell>
                    <CTableHeaderCell scope="col">
                      <div align="center">
                        <MessageCircle size={22} />
                      </div>
                    </CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {customers.map((customer, index) => {
                    return (
                      //<CTableRow key={index} onClick={() => fetchCustomerById(customer.id)} ref={g_graph2_enviado}>
                      <CTableRow key={index} onClick={() => fetchCustomerById(customer.id)} >
                        <CTableHeaderCell scope="row">
                          <CAvatar color="light" textColor="dark" style={{ backgroundImage: `url(${customer.profile_pic})`, backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}></CAvatar>
                        </CTableHeaderCell>
                        <CTableDataCell>
                          <span className="text-color">{customer.name}</span>
                          <AlertTriangle style={{ color: "red" }} size={18} />
                          {customer.link_usadao
                            ? <CBadge style={{ marginLeft: "15px" }} color="warning" href={customer.link_usadao}>#{customer.usadao_id}</CBadge>
                            : <CBadge style={{ marginLeft: "15px" }} color="dark">Sem cadastro</CBadge>}
                        </CTableDataCell>
                        <CTableDataCell>
                          <span className={`message-box-date text-color`}>
                            {moment(customer.createdAt).format("LL")}
                          </span>
                        </CTableDataCell>
                        <CTableDataCell>
                          {customer.status
                            ? <CBadge color="success">Ativo</CBadge>
                            : <CBadge color="danger">Inativo</CBadge>}
                        </CTableDataCell>
                        <CTableDataCell>
                          {customer.approved
                            ? <CBadge color="success">Aprovado</CBadge>
                            : <CBadge color="danger">Desaprovado</CBadge>}
                        </CTableDataCell>
                        <CTableDataCell>
                          {/* <div align="center"><button className="btn btn-warning" type="submit" onClick={() => {setButtonPopupSocialMediaFilter(true); pegaSocialMedia(customer.id)}}>+Chat</button></div> */}
                        </CTableDataCell>
                      </CTableRow>
                    )
                  })}
                </CTableBody>
              </CTable>
            </>
          )}
        </div>
      </div>

      <div className="customer">
        <div className="header border-left">
          <span>
            Informações
          </span>
          {info && info.usadao_id != '' &&
            <a href={`https://usadaomaquinas.com.br/Gerencial_web32yw/PG_Clientes/DashCliente.php?Codigo=` + info.usadao_id} target="_blank">
              <button className="action-btn">
                <img src={require("../imgs/icon-colored.png")} />
              </button>
            </a>
          }
        </div>

        {info ? (
          <div className="chat-user">
            <div className="box no-bg">
              <div className="box-avatar-wrapper">
                <div className="box-avatar" style={{ backgroundImage: `url(${info.profile_pic})` }}></div>
              </div>
              {info && info.usadao_id != '' && (
                <span className="chat-user-id">#{info.usadao_id}</span>
              )}
              <span className="chat-user-username">{info.nickname}</span>
              <span className="chat-user-name">{info.name && info.name}</span>
              {info.dataAniversario && (
                <span className="chat-user-username">Idade: {info.year} anos</span>)
              }

              {info.ultimaVizualizacao && (
                <span className="chat-user-username">Ultimo login no leilão:</span>)}
              {info.ultimaVizualizacao && (
                <span className="chat-user-id">{moment(info.ultimaVizualizacao).format('LLL')}</span>)}

              {info.city_name && info.state_name && (
                <span className="chat-user-username">{info.city_name} / {info.state_name}</span>)
              }
            </div>

            <Box title="Redes sociais">
              {info.socialMedias.map(media => {
                return (
                  <img src={`${media.icon}`} style={{ marginRight: "10px" }} />
                )
              })}

              <div style={{ height: "15px" }}></div>
            </Box>

            {info && <ChartHours user={info.id} />}

          </div>
        ) : (
          infoLoading ? (
            <LoadingCenter />
          ) : (
            <div className="div-center pt-20 pl-20 pr-20 text-center">
              <Any />
              <span className="chat-user-name">Nenhum cliente</span>
              <span className="chat-user-username">
                Você deve selecionar um cliente para visualizar as informações
              </span>
            </div>
          )
        )}

      </div>
    </div>
  );
}

export default JuridicCustomers;